import React from 'react';
import { CheckCircle2Icon, TargetIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCta } from '../SectionCta';
import { volumes } from '../../data/volumes';
export function Volumes() {
  return <section aria-labelledby="volumes" className="bg-paper px-4 py-16 sm:py-24" data-id="element-360" data-mp="2wzgoezzufs2k">
      <div className="mx-auto max-w-4xl" data-id="element-361" data-mp="2sywqvvbcymfw">
        <div id="volumes" data-id="element-362" data-mp="2o0lg9id8o7wm">
          <SectionHeading kicker="What’s inside the ABG Clinical Roadmap™" title="Six educational volumes to organize your ABG studies" subtitle="Each volume focuses on a specific area of learning, taking you from foundational concepts to interpretation principles and simulated practice." data-id="element-363" data-mp="2o0v87bhugp4y" />
        </div>

        <div className="mt-12 space-y-6" data-id="element-364" data-mp="299mcckncm7jd">
          {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl bg-white shadow-[0_10px_30px_-18px_rgba(10,29,69,0.35)] ring-1 ring-ink/10" data-id="element-365" data-mp="259kjn0zlcog8">
              <div className="flex items-stretch" data-id="element-366" data-mp="335w5n0w38wtd">
                <div className="flex w-20 shrink-0 flex-col items-center justify-center py-5 text-white sm:w-28" style={{
              backgroundColor: v.color
            }} data-id="element-367" data-mp="3342v3aictsg3">
                  <span className="text-[10px] font-bold uppercase tracking-[0.2em] opacity-85" data-id="element-368" data-mp="2u6sklrdd27c8">Volume</span>
                  <span className="font-display text-4xl font-black leading-none sm:text-5xl" data-id="element-369" data-mp="2y4glrc5ncwck">{v.numeral}</span>
                </div>
                <div className="flex-1 p-5 sm:p-7" data-id="element-370" data-mp="3quyoud6dexpz">
                  <h3 className="font-display text-[1.35rem] font-black leading-tight text-ink sm:text-2xl" data-id="element-371" data-mp="3qufebhj1vblz">{v.title}</h3>
                  <p className="mt-1.5 font-semibold leading-snug" style={{
                color: v.color
              }} data-id="element-372" data-mp="3cxs2y9qcoiwj">
                    {v.subtitle}
                  </p>
                </div>
              </div>

              <div className="px-5 pb-6 pt-5 sm:px-7 sm:pb-7" data-id="element-373" data-mp="21id6d721zt1y">
                <p className="leading-relaxed text-ink/75" data-id="element-374" data-mp="26g51e9xzvvad">{v.intro}</p>

                <h4 className="mt-6 text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-375" data-mp="bzofxyms6x3a">Inside Volume {v.numeral}</h4>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-376" data-mp="71d81tg1qwnp">
                  {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink/85" data-id="element-377" data-mp="27isn27h53uf">
                      <CheckCircle2Icon className="mt-0.5 h-[18px] w-[18px] shrink-0" style={{
                  color: v.color
                }} aria-hidden="true" data-id="element-378" data-mp="3ucw35ld8hizg" />
                      {item}
                    </li>)}
                </ul>

                <div className="mt-6 flex gap-3 rounded-2xl bg-paper p-4" data-id="element-379" data-mp="3ffvmccwkz8fr">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-700" aria-hidden="true" data-id="element-380" data-mp="3fhy82kqpafeo" />
                  <p className="text-[15px] leading-snug text-ink" data-id="element-381" data-mp="3bgd1fh4rexcx">
                    <strong data-id="element-382" data-mp="1dn7f7sgtg0up">Your takeaway: </strong>
                    {v.takeaway}
                  </p>
                </div>
                {v.note && <p className="mt-3 text-xs leading-relaxed text-ink/50" data-id="element-383" data-mp="19l2niz9xheap">{v.note}</p>}
              </div>
            </article>)}
        </div>

        <SectionCta label="Yes! Give me all 6 volumes for $27" data-id="element-384" data-mp="2wild6i6tkrf3" />
      </div>
    </section>;
}